const WORLD_MAP_IMG = `${process.env.PUBLIC_URL}/images/Wordmap.png`;

/** Hub positions in SVG viewBox units (0–100 × 0–50), aligned to Wordmap.png. */
const HUBS = [
  { x: 15, y: 20 }, // California
  { x: 21, y: 22 }, // Dallas
  { x: 24, y: 22 }, // North Carolina
  { x: 52, y: 18 }, // Europe
  { x: 68, y: 25 }, // India
  { x: 30, y: 35 }, // South America
  { x: 80, y: 38 }, // Australia
  { x: 55, y: 30 }, // Africa
] as const;

const CONNECTIONS: { from: number; to: number; lift?: number }[] = [
  { from: 0, to: 1, lift: 2 }, // California ↔ Dallas
  { from: 1, to: 2, lift: 2 }, // Dallas ↔ North Carolina
  { from: 1, to: 3 }, // Dallas → Europe
  { from: 0, to: 4 }, // California → India
  { from: 2, to: 5 }, // North Carolina → South America
  { from: 3, to: 4 }, // Europe → India
  { from: 3, to: 7 }, // Europe → Africa
  { from: 4, to: 7 }, // India → Africa
  { from: 4, to: 6 }, // India → Australia
  { from: 7, to: 5 }, // Africa → South America
  { from: 1, to: 7 }, // Dallas → Africa
  { from: 7, to: 6 }, // Africa → Australia
];

function arcPath(
  from: { x: number; y: number },
  to: { x: number; y: number },
  lift = 6,
) {
  const mx = (from.x + to.x) / 2;
  const my = Math.min(from.y, to.y) - lift;
  return `M ${from.x} ${from.y} Q ${mx} ${my} ${to.x} ${to.y}`;
}

export default function IndustriesWorldMap() {
  return (
    <div className="ind-world-map" aria-hidden>
      <div className="ind-world-map__stage">
      <img
        src={WORLD_MAP_IMG}
        alt=""
        className="ind-world-map__img"
        width={960}
        height={480}
        decoding="async"
      />
      <svg
        className="ind-world-map__overlay"
        viewBox="0 0 100 50"
        preserveAspectRatio="xMidYMid meet"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <filter id="ind-hub-glow" x="-100%" y="-100%" width="300%" height="300%">
            <feGaussianBlur stdDeviation="0.35" result="blur" />
            <feMerge>
              <feMergeNode in="blur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>

        {CONNECTIONS.map(({ from: a, to: b, lift }, connIndex) => {
          const fromHub = HUBS[a];
          const toHub = HUBS[b];
          if (!fromHub || !toHub) return null;
          const d = arcPath(fromHub, toHub, lift);
          const duration = 2.2 + (connIndex % 5) * 0.4;
          const reverse = connIndex % 2 === 1;

          return (
            <g key={`${a}-${b}`}>
              <path d={d} pathLength={1} className="ind-world-map__arc ind-world-map__arc--dark" fill="none" />
              <path
                d={d}
                pathLength={1}
                className={`ind-world-map__arc ind-world-map__arc--flow${reverse ? ' ind-world-map__arc--flow-reverse' : ''}`}
                fill="none"
                style={{ animationDuration: `${duration}s` }}
              />
            </g>
          );
        })}

        {HUBS.map((hub, i) => (
          <g key={i} filter="url(#ind-hub-glow)">
            <circle cx={hub.x} cy={hub.y} r={1.1} className="ind-world-map__hub-outer" />
            <circle cx={hub.x} cy={hub.y} r={0.5} className="ind-world-map__hub" />
          </g>
        ))}
      </svg>
      </div>
    </div>
  );
}
